<template>
<div :class="{'pp-artist-grid':1, 'pp-artist-grid--mobile-horizontal': mobileHorizontal }" :style="{ 'max-height': maxRows ? (($root.view == 'mobile' ? 162 : 180) * maxRows) + 'px' : '' }">
    <router-link :to="linkTo ? linkTo.replace('{id}', item.id) : ''" v-for="item in items" :key="item.id" class="pp-artist-grid__item">
        <div :style="{'background-image': item.thumbnail ? 'url('+item.thumbnail+')' : null}" class="pp-artist-grid__item__artwork">
            <img :src="item.thumbnail" class="">
            <span v-if="!item.thumbnail" class="pp-artist-grid__item__initials">
                {{
                    useLastnamePlaceholder
                        ? item.display_name.split(' ').reverse()[0].substring(0, 1)
                        : item.display_name.substring(0, 1)
                }}
            </span>
        </div>
        <div class="pp-artist-grid__item__title">
            <div>{{ item.display_name }}</div>
        </div>
    </router-link>
    <loading-indicator v-if="paginating"></loading-indicator>
</div>
</template>

<script>
import Ellipsis from 'ftellipsis';
import LoadingIndicator from './LoadingIndicator.vue';
import EventBus from '../EventBus.js'

export default {
    name: 'artist-grid',
    data() {
        return {
            titleEllipsis: [],
        };
    },
    props: {
        items: Array,
        maxRows: Number,
        linkTo: String,
        mobileHorizontal: Boolean,
        canPaginate: Boolean,
        paginating: Boolean,
        reachedEnd: Boolean,
        useLastnamePlaceholder: Boolean,
    },
    watch: {
        items() {
            console.log('ITEMS CHANGED, RESIZING');
            Vue.nextTick(() => {
                this.getTitleElements();
                this.onResize();
            });
        }
    },
    methods: {
        loadMore(items) {
            for (var item of items) {
                this.items.push(item);
            }
            this.getTitleElements();
            this.onResize();
        },
        getTitleElements() {
            let elements = this.$el.querySelectorAll('.pp-artist-grid__item__title');
            for (let element of elements) {
                element.style.lineHeight = '18px';
                var ellip = new Ellipsis(element);
                ellip.calc();
                ellip.set();

                this.titleEllipsis.push(ellip);
            }
        },

        onResize() {
            for (let ellip of this.titleEllipsis) {
                element.style.lineHeight = '18px';
                ellip.calc();
                ellip.set();
            }
        }

    },
    mounted() {
        this.getTitleElements();
        window.addEventListener('resize', () => this.onResize());

        window.addEventListener('resize', () => {
            for (let ellip of this.titleEllipsis) {
                ellip.calc();
                ellip.set();
            }
        });

        EventBus.on('navigation.scrolling', (e) => {
            if (this.canPaginate && !this.reachedEnd && !this.paginating && e.data.fromBottom < 300) {
                this.$emit('paginate');
            }
        })
    }
};
</script>



// WEBPACK FOOTER //
// ArtistGrid.vue?1a3cebb4